import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Drawer from 'material-ui/Drawer';
import {List, ListItem, makeSelectable} from 'material-ui/List';
import {spacing, typography, zIndex} from 'material-ui/styles';
import Authorization, {RoleAuthorization} from '../containers/Authorization';

let SelectableList = makeSelectable(List);

function wrapState(ComposedComponent) {

  return class SelectableList extends Component {
    static propTypes = {
      children: PropTypes.node.isRequired,
      defaultValue: PropTypes.string.isRequired,
    };

    componentWillMount() {
      this.setState({
        selectedIndex: this.props.value?  this.props.value : this.props.defaultValue,
      });
    }

    handleRequestChange = (event, index) => {
      console.log(index);
      this.setState({
        selectedIndex: index,
      });
    };

    render() {
      const selectedItemStyle = {
        backgroundColor: '#FFD642'
      }
      return (
        <ComposedComponent
          value={this.state.selectedIndex}
          selectedItemStyle={selectedItemStyle}
          onChange={this.handleRequestChange}
        >
          {this.props.children}
        </ComposedComponent>
      );
    }
  };
}

SelectableList = wrapState(SelectableList);

const styles = {
  v1: {
    height: 0,
  },
  logo: {
    cursor: 'pointer',
    fontSize: 23,
    color: typography.textFullWhite,
    lineHeight: `${spacing.desktopKeylineIncrement}px`,
    fontWeight: typography.fontWeightLight,
    backgroundColor: '#1cb7ff',
    marginBottom: 8,
    paddingLeft: 20,
    textAlign: 'left'
  },
  logoImg:{
    height: 30,
    width: 100,
    marginTop: 10,
    position: 'relative',
    top: 7,
  },
  hubName: {
    fontSize: 22,
    fontWeight: 300,
    color: '#fff',
    textTransform: 'uppercase',
    marginLeft: 3,
  },
  version: {
    paddingLeft: spacing.desktopGutterLess,
    fontSize: 16,
  },
};

const listItemStyle = {
    margin: 10,
    marginLeft:'10px',
    marginRight:'10px',
    borderRadius:'5px',
    fontSize: 18,
    fontWeight:'600',
    minHeight: 50,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
};
const listItemLinkStyle = {
  ...listItemStyle,
  cursor: 'pointer'
};

class AppNavDrawer extends Component {
  static propTypes = {
    docked: PropTypes.bool.isRequired,
    onRequestChangeNavDrawer: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    style: PropTypes.object,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: '/website/content'
    };
  }

  handleTouchTapHeader = () => {
    this.props.onRequestChangeNavDrawer(false);
  };

  getRootNavList(){
    if (this.props.authRole.toLowerCase() === 'iqmetrix'){
      if (this.props.selectedCompany){
        return this.getCompanyNav(this.props.selectedCompany);
      } else {
        return [
          <ListItem key="0" containerElement={<Link to={`/companies`} />} style={listItemStyle} primaryText="Companies" value="/companies" />,
        ]
      }
    } else {
      return this.getCompanyNav(null);
    }
  }

  getCompanyNav(companyId){
    let WebSiteListItem = Authorization(['readyWebsite'],ListItem);
    let AdminListItem = RoleAuthorization(['Systems Admin'],ListItem);
    if (companyId){
      return [
        <WebSiteListItem key="0" containerElement={<Link to={`/company/${companyId}/website/websitesettings`} />} style={listItemStyle} primaryText="Website" value="/website/websitesettings" />,
        <WebSiteListItem key="2" containerElement={<Link to={`/company/${companyId}/menus`} />} style={listItemStyle} primaryText="Menus" value="/menus" />,
        <ListItem key="3" containerElement={<Link to={`/company/${companyId}/locations`} />} style={listItemStyle} primaryText="Locations" value={`/company/${companyId}/locations`} />,
        <ListItem key="4" containerElement={<Link to={`/company/${companyId}/stations`} />} style={listItemStyle} primaryText="All Stations" value={`/company/${companyId}/stations`} />,
        <ListItem key="5" containerElement={<Link to={`/company/${companyId}/users`} />} style={listItemStyle} primaryText="All Users" value={`/company/${companyId}/users`} />,
        <ListItem key="6" containerElement={<Link to={`/company/${companyId}/waitlist`}  />} style={listItemStyle} primaryText="Waitlist Settings" value={`company/${companyId}/waitlist`} />,
        <AdminListItem key="7" containerElement={<Link to={`/company/${companyId}/settings`} />} style={listItemStyle} primaryText="Settings" value={`company/${companyId}/website/settings`} /> ];
    } else {
      return [
        <WebSiteListItem key="0" containerElement={<Link to="/website/home" />} style={listItemStyle} primaryText="Website" value="/website/home" />,
        <WebSiteListItem key="2" containerElement={<Link to="/menus" />} style={listItemStyle} primaryText="Menus" value="/menus" />,
        <ListItem key="3" containerElement={<Link to="/locations" />} style={listItemStyle} primaryText="Locations" value="/locations" />,
        <ListItem key="4" containerElement={<Link to="/stations" />} style={listItemStyle} primaryText="iPad Stations" value="/stations" />,
        <ListItem key="5" containerElement={<Link to="/users" />} style={listItemStyle} primaryText="Users" value="/users" />,
        <ListItem key="6" containerElement={<Link to="/waitlist" />} style={listItemStyle} primaryText="Waitlist Settings" value="/waitlist" />,
        <AdminListItem key="7" containerElement={<Link to="/settings" />} style={listItemStyle} primaryText="Settings" value="/website/settings" /> ];
    }
  }

  render() {

    const {
      docked,
      onRequestChangeNavDrawer,
      open,
      style,
    } = this.props;
    let loggedIn = window.localStorage.getItem('auth_token');
    return (
      <Drawer
        style={style}
        docked={docked}
        open={open}
        onRequestChange={onRequestChangeNavDrawer}
        containerStyle={{zIndex: zIndex.drawer - 100}}
      >
        <div style={styles.v1} />
        <div style={styles.logo} onTouchTap={this.handleTouchTapHeader}>
          <img src="/ready-logo-white.png" style={styles.logoImg} alt="Ready Logo"/>
          <span style={styles.hubName}>Hub</span>
        </div>

        {loggedIn && this.props.selectedCompany?
          <div style={listItemLinkStyle} onClick={this.props.deselectCompany}>&lt; Back</div>
          :
          null
        }

        {loggedIn?
          <SelectableList
            value={this.props.path}
            defaultValue="/website"
          >
            {
              this.getRootNavList()
            }
          </SelectableList>
          :
          null
        }
      </Drawer>
    );
  }
}

export default AppNavDrawer;



// WEBPACK FOOTER //
// ./src/components/AppNavDrawer.js